import React from 'react';

import CloseButtonContainer from 'presentation/containers/CloseButtonContainer';
import overrideStyle from 'lib/overrideStyle';
import SearchContainer from 'presentation/selfService/Search';

const HeaderWrapper = overrideStyle('div')`
  align-items: center;
  background: ${props => props.colors.primary};
  border-bottom: 1px solid #dddddd;
  border-radius: 10px 10px 0px 0px;
  display: flex;
  justify-content: center;
  height: 100px;
  position: absolute;
  top: 0px;
  width: 364px;
`;

const Title = overrideStyle('div')`
  color: #ffffff;
`;

export default function Header(props) {
  return (
    <HeaderWrapper colors={props.colors}>
      {/* TODO: fetch from config */}
      <Title>{'Hello! How can we help you?'}</Title>
      <CloseButtonContainer />
      <SearchContainer />
    </HeaderWrapper>
  );
}
